module.exports = __webpack_public_path__ + "static/img/salon_banner_01_zh.118db0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salon_banner_01_zh.png
// module id = 3I8v
// module chunks = 34